import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["placeholder", "inputRef"];
import { useMemo } from 'react';
import I18n from 'I18n';
import { useTaxCategories } from '../../v2/hooks/useTaxCategories';
import SelectAdapter from '../../adapters/Select';
import unescapedText from 'I18n/utils/unescapedText';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
import { jsx as _jsx } from "react/jsx-runtime";
const getGroupName = group => {
  var _physical$digital$ser;
  return (_physical$digital$ser = {
    physical: I18n.text('customerDataProperties.TaxCategorySelect.groups.physical'),
    digital: I18n.text('customerDataProperties.TaxCategorySelect.groups.digital'),
    services: I18n.text('customerDataProperties.TaxCategorySelect.groups.services')
  }[group]) !== null && _physical$digital$ser !== void 0 ? _physical$digital$ser : group;
};
const TaxCategorySelect = _ref => {
  let {
      placeholder = unescapedText('customerDataProperties.TaxCategorySelect.placeholder'),
      inputRef
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const categories = useTaxCategories();
  const options = useMemo(() => {
    return Object.values(categories.reduce((acc, category) => {
      var _acc$group;
      const group = category.additionalFields.group;
      (_acc$group = acc[group]) !== null && _acc$group !== void 0 ? _acc$group : acc[group] = {
        text: getGroupName(group),
        options: []
      };
      acc[group].options.push({
        text: category.label,
        value: category.id
      });
      return acc;
    }, {}));
  }, [categories]);
  const loading = categories.length === 0;
  return /*#__PURE__*/_jsx(SelectAdapter, Object.assign({}, props, {
    inputRef: inputRef,
    value: loading ? '' : props.value,
    placeholder: loading ? '' : placeholder,
    isLoading: loading,
    minimumSearchCount: 0,
    options: options
  }));
};
export default TaxCategorySelect;